import React, { Component } from 'react';

const connectCommon = (WrappedComponent) => {
    return class CommonHOC extends Component {
        constructor(props) {
            super(props);

            this.state = { startDate: null };

            this.saveScreenDuration = this.saveScreenDuration.bind(this);
            this.saveData = this.saveData.bind(this);
        }

        componentDidMount() {
            this.setState({ startDate: new Date()});
        }

        componentWillUnmount() {
            this.saveData();
        }

        saveScreenDuration() {
            this.props.setScreenDuration(this.props.location.pathname, this.state.startDate, new Date());
            this.setState({ startDate: new Date()});
        }

        saveData(handled) {
            this.saveScreenDuration();

            this.props.save();
        }

        render() {
            return (
                <WrappedComponent saveData={this.saveData} saveScreenDuration={this.saveScreenDuration} {...this.props} />
            )
        }
    }
}

export default connectCommon;